export default {
  SET_ORDER: (state, payload) => {
    state.order = payload;
  },
  SET_PCODE: (state, payload) => {
    state.pcode = payload;
  },
  SET_INVENTORY: (state, payload) => {
    state.inventory = payload;
  },
  SET_REFERENCE: (state, payload) => {
    state.promo = payload;
  },
  SET_DO: (state, payload) => {
    state.deliveryOrder = payload
  },
  SET_WARRANTY: (state, payload) => {
    state.warranty = payload
  },
  SET_SKIP_SCAN: (state,payload)=>{
    state.skipScan = payload
  },
  SET_RETURN: (state,payload)=>{
    state.return = [payload]
  }
}
